import { defaultApi } from '@/api';
import { TenantEntities } from '@/features/canvas/api/tenant-sso';
import { components } from '@/types/api';

export async function getPublicLinks() {
  const { data } = await defaultApi.get<components['schemas']['PublicLinkResponse'][]>(
    '/public-links'
  );
  return data;
}

export async function deletePublicLink(linkId: number) {
  await defaultApi.delete(`/public-links/${linkId}`);
}

export async function editPublicLink(publicLink: components['schemas']['PublicLink']) {
  const { data } = await defaultApi.put(`/public-links/${publicLink.id}`, [publicLink]);
  return data;
}

export async function getPublicLinkViewers({ id }: { id: number }) {
  const { data } = await defaultApi.get(`/public-links/${id}/viewers`);
  return data;
}

export async function getViewerGroups(id: number) {
  const { data } = await defaultApi.get(`/public-links/viewers/${id}/groups`);
  return data;
}

export async function editViewerGroups(id: number, groups: number[]) {
  const { data } = await defaultApi.patch(`/public-links/viewers/${id}/groups`, { groups });
  return data;
}

export async function getGroupMembers(id: number) {
  const { data } = await defaultApi.get(`/public-links/groups/${id}/members`);
  return data;
}

export async function editGroupMembers(id: number, members: number[]) {
  const { data } = await defaultApi.patch(`/public-links/groups/${id}/members`, { members });
  return data;
}

export async function importMembers(id: number, file: File) {
  const formData = new FormData();
  formData.append('file', file);

  const { data } = await defaultApi.post(`/public-links/groups/${id}/members`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function createViewer({ name, email }: { email: string; name?: string }) {
  const { data } = await defaultApi.put('/public-links/viewers', { name, email });
  return data;
}

export async function createGroup({ name }: { name: string }) {
  const { data } = await defaultApi.put('/public-links/groups', { name });
  return data;
}

export async function deleteViewer(id: number) {
  const { data } = await defaultApi.delete(`/public-links/viewers/${id}`);
  return data;
}

export async function deleteGroup(id: number) {
  const { data } = await defaultApi.delete(`/public-links/groups/${id}`);
  return data;
}

export async function copyGroup(id: number) {
  const { data } = await defaultApi.post(`/public-links/groups/${id}`);
  return data;
}

export async function editPublicLinkViewers(id: number, entities: TenantEntities) {
  const groups = entities.groups.map(item => item.id);
  const viewers = entities.viewers.map(item => item.id);

  const { data } = await defaultApi.patch(`/public-links/${id}/viewers`, { groups, viewers });
  return data;
}

export async function importViewers(file: File) {
  const formData = new FormData();
  formData.append('file', file);

  const { data } = await defaultApi.post('/public-links/viewers/import', formData, {
    headers: { 'Content-Type': `multipart/form-data` },
  });
  return data;
}

export async function getViewers(params?: string) {
  const { data } = await defaultApi.get<TenantEntities['viewers']>(
    '/public-links/viewers/?' + params
  );
  return data;
}

export async function editGroup(id: number, input: TenantEntities['groups'][number]) {
  const { data } = await defaultApi.patch(`/public-links/groups/${id}`, { ...input });
  return data;
}

export async function editViewer(id: number, input: { name: string; email: string }) {
  const { data } = await defaultApi.patch(`/public-links/viewers/${id}`, { ...input });
  return data;
}
